import { UserResponse } from "../types/types"
import { genericRequest, userRoute } from "./service"

/**
 * Gets user for a given user id.
 * 
 * @param userId id of the user to fetch
 * 
 * @returns response
 */
export const getUser = async (userId: number): Promise<UserResponse | Error> => {
  return genericRequest({ url: `${userRoute}/${userId}`, method: "GET" })
}

/**
 * Gets the current signed in user.
 * 
 * @returns current signed in user
 */
export const getCurrentUser = async (): Promise<UserResponse | Error> => {
  return genericRequest({ url: `${userRoute}/current`, method: "GET" })
}